import * as React from 'react'
import {
  FormTextArea,
  FormEuroField
} from '@espoon-voltti/react-voltti/components/form'
import { Columns, Column } from '@espoon-voltti/react-components/elements'
import { Spacing } from '@espoon-voltti/react-components/layout'
import { EuroCents } from '@espoon-voltti/ts-libs/lib/euro'

import { t } from '../../../../i18n'
interface Props {
  lastYearDay: string
}

export const maxValue = EuroCents.fromValue(999999_00)

export const GeneralGrantFormPreviousYear: React.FC<Props> = (p) => (
  <Columns>
    <Column size={10}>
      <Spacing spacing={['margin-top--2']}>
        <div />
      </Spacing>

      <Columns>
        <Column>
          <FormEuroField
            required={true}
            name={'form.previousYear.totalProfitInCents'}
            dataQa={'totalProfitInCents'}
            min={-maxValue.euros()}
            max={maxValue.euros()}
            label={t([
              'views',
              'generalGrant',
              'form',
              'previousYear',
              'totalProfitInCents'
            ])}
          />
        </Column>
        <Column>
          <FormEuroField
            required={true}
            name={'form.previousYear.bankAccountSumInCents'}
            min={-maxValue.euros()}
            max={maxValue.euros()}
            dataQa={'bankAccountSumInCents'}
            label={t(
              [
                'views',
                'generalGrant',
                'form',
                'previousYear',
                'bankAccountSumInCents'
              ],
              { lastDayOfPreviousYear: p.lastYearDay }
            )}
          />
        </Column>
        <Column>
          <FormEuroField
            required={true}
            name={'form.previousYear.selfAcquiredFundsInCents'}
            dataQa={'selfAcquiredFundsInCents'}
            label={t([
              'views',
              'generalGrant',
              'form',
              'previousYear',
              'selfAcquiredFundsInCents'
            ])}
          />
        </Column>
      </Columns>
      <Columns>
        <Column>
          <FormTextArea
            required={true}
            name={'form.previousYear.receivedGrants'}
            dataQa={'receivedGrants'}
            label={t([
              'views',
              'generalGrant',
              'form',
              'previousYear',
              'receivedGrants',
              'label'
            ])}
          />
        </Column>
      </Columns>
    </Column>
  </Columns>
)
